import classNames from 'classnames';
import type { FC, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { SystemButton } from '../SystemButton/SystemButton';

export type PageHeaderProps = HTMLAttributes<HTMLDivElement> & {
  elevated?: boolean;
  width?: 'content-default' | 'full';
  label: ReactNode;
  buttons?: ReactNode;
  additionalControls?: ReactNode;
  onBackButtonClick?: () => void;
};

const widthClassName: {
  [Key in NonNullable<PageHeaderProps['width']>]: string;
} = {
  'content-default': 'max-w-content-default',
  full: '',
};

export const PageHeader: FC<PageHeaderProps> = ({
  className,
  elevated = false,
  width = 'full',
  label,
  buttons,
  additionalControls,
  onBackButtonClick,
  ...restProps
}) => {
  return (
    <div
      className={twMerge(
        classNames(
          'sticky top-0 z-pageHeader w-full flex flex-row justify-around bg-default py',
          elevated && 'shadow-lg',
        ),
        className,
      )}
      {...restProps}
    >
      <div
        className={classNames(
          'w-full flex flex-row justify-between gap px',
          widthClassName[width],
        )}
      >
        <div className='flex items-center gap-xs'>
          {onBackButtonClick !== undefined && (
            <SystemButton
              icon='fa-angle-left'
              onClick={onBackButtonClick}
              size='large'
            />
          )}
          <div className='flex items-center gap-2'>
            <div className='text-default text-level-3 font-semibold'>
              {label}
            </div>
            {additionalControls && <div>{additionalControls}</div>}
          </div>
        </div>
        <div className='flex flex-row gap-xs'>{buttons}</div>
      </div>
    </div>
  );
};
